<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Supplier Name</label>
                  <b-form-input type="text" v-model="form.vendorname" ref='firstInput' @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Contact Person</label>
                  <b-form-input type="text"  v-model="form.contactperson" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Address</label>
                  <b-form-input type="text"  v-model="form.address" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Email</label>
                  <b-form-input type="text"  v-model="form.email" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>Phone</label>
                  <InternationalPhoneInput
                    ref="phoneInput"
                    v-model="form.phone"
                    :submitted="phoneSubmitted"
                    @enter="submitForm()"
                  />
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 col-12">
                <div class="form-group">
                  <label>GSTIN</label>
                  <b-form-input type="text" v-model="form.gstin" maxlength="15" @keypress.enter="submitForm()"/>
                </div>
              </div>
              <!-- <div class="col-lg-9 col-12">
                <div class="form-group">
                  <label>Address</label>
                  <input type="text" />
                </div>
              </div>
              <div class="col-lg-12">
                <div class="form-group">
                  <label>Description</label>
                  <textarea class="form-control"></textarea>
                </div>
              </div> -->
              <!-- <div class="col-lg-12">
                <div class="form-group">
                  <label> Avatar</label>
                  <div class="image-upload">
                    <input type="file" />
                    <div class="image-uploads">
                      <img src="../../../assets/img/icons/upload.svg" alt="img" />
                      <h4>Drag and drop a file to upload</h4>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="col-lg-12">
                <a v-on:click="postData()" class="btn btn-submit me-2">Submit</a>
                <router-link to="supplierlist" class="btn btn-cancel">Cancel</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import InternationalPhoneInput from "@/components/InternationalPhoneInput.vue";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
export default {
  components: { InternationalPhoneInput },
  data() {
    return {
      form: {
        vendorname: '',
        contactperson: '',
        address: '',
        email: '',
        phone: '',
        gstin: '',
      },
      phoneSubmitted: false,
      title: "Add Supplier",
      title1: "Create new supplier",
    };
  },
  methods: {
    async postData() {
      if (!this.form.vendorname) {
        Swal.fire("Please enter the Suppiler name");
        return;
      }
      this.phoneSubmitted = true;
      if (!this.$refs.phoneInput.validate()) {
        Swal.fire("Please enter a valid phone number");
        return;
      }
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to submit the form?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      });

      if (result.isConfirmed) {
      axios
      .post('/v1/vendors', this.form)
      .then(response => {
        //this.res = "Status " + response.status + ". Category created";
        Swal.fire("Supplier created successfully");
        this.$router.push({ path: '/supplierlist' });
      })
      .catch(error => {
        console.log(error)
        Swal.fire(error.response.data.detail);
      });
      }
    },
    submitForm() {
      this.postData();
    }
  },
  mounted(){
    this.$refs.firstInput.focus();
  },
  name: "addsupplier",
};
</script>


